<template>
  <div>
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入订单编号" suffix-icon="el-icon-search" v-model="orderNo"></el-input>
      <el-input style="width: 200px" placeholder="请输入支付人" suffix-icon="el-icon-user" class="ml-5" v-model="username"></el-input>
      <el-select v-model="tradeState" placeholder="交易状态" style="width: 150px" class="ml-5" clearable>
        <el-option label="支付成功" value="SUCCESS"></el-option>
        <el-option label="未支付" value="NOTPAY"></el-option>
        <el-option label="已关闭" value="CLOSED"></el-option>
      </el-select>
      <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>

    <div style="margin: 10px 0">
      <el-popconfirm
          confirm-button-text='确定'
          cancel-button-text='我再想想'
          icon="el-icon-info"
          icon-color="red"
          title="您确定批量删除这些数据吗？"
          @confirm="delBatch"
      >
        <el-button type="danger" slot="reference">批量删除 <i class="el-icon-remove-outline"></i></el-button>
      </el-popconfirm>
    </div>

    <el-table :data="tableData" border stripe :header-cell-class-name="'headerBg'"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80" sortable></el-table-column>
      <el-table-column prop="username" label="支付人" width="120"></el-table-column>
      <el-table-column prop="orderNo" label="订单编号" width="200"></el-table-column>
      <el-table-column prop="transactionId" label="交易编号" width="200"></el-table-column>
      <el-table-column prop="paymentType" label="支付类型" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paymentType === '微信' || scope.row.paymentType === 'wxpay'" 
                  style="background-color: #07C160; color: white; border: none;">
            <i class="el-icon-chat-dot-square"></i> 微信
          </el-tag>
          <el-tag v-else-if="scope.row.paymentType === '支付宝' || scope.row.paymentType === 'alipay'" 
                  style="background-color: #1677FF; color: white; border: none;">
            <i class="el-icon-coin"></i> 支付宝
          </el-tag>
          <el-tag v-else type="info">{{ scope.row.paymentType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="tradeType" label="交易类型" width="100" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" size="small">{{ scope.row.tradeType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="tradeState" label="交易状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.tradeState === 'SUCCESS'" type="success" effect="dark">
            <i class="el-icon-circle-check"></i> 支付成功
          </el-tag>
          <el-tag v-else-if="scope.row.tradeState === 'NOTPAY'" type="warning" effect="dark">
            <i class="el-icon-warning"></i> 未支付
          </el-tag>
          <el-tag v-else-if="scope.row.tradeState === 'CLOSED'" type="info" effect="dark">
            <i class="el-icon-circle-close"></i> 已关闭
          </el-tag>
          <el-tag v-else>{{ scope.row.tradeState }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payerTotal" label="支付金额" width="120">
        <template slot-scope="scope">
          <span style="color: #f56c6c; font-weight: bold;">¥{{ (scope.row.payerTotal / 100).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleView(scope.row)">
            <i class="el-icon-view"></i> 查看
          </el-button>
          <el-popconfirm
              class="ml-5"
              confirm-button-text='确定'
              cancel-button-text='我再想想'
              icon="el-icon-info"
              icon-color="red"
              title="您确定删除吗？"
              @confirm="del(scope.row.id)"
          >
            <el-button type="danger" size="small" slot="reference">
              <i class="el-icon-remove-outline"></i> 删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <el-dialog title="支付记录详情" :visible.sync="dialogFormVisible" width="600px" :close-on-click-modal="false">
      <el-card class="payment-detail-card" shadow="never">
        <div class="detail-row">
          <div class="detail-label">记录ID：</div>
          <div class="detail-value">{{ currentPayment.id }}</div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">支付人：</div>
          <div class="detail-value">
            <i class="el-icon-user"></i> {{ currentPayment.username }}
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">订单编号：</div>
          <div class="detail-value">
            <el-tag type="info" size="small">{{ currentPayment.orderNo }}</el-tag>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">交易编号：</div>
          <div class="detail-value">
            <el-tag type="primary" size="small">{{ currentPayment.transactionId }}</el-tag>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">支付类型：</div>
          <div class="detail-value">
            <el-tag v-if="currentPayment.paymentType === '微信' || currentPayment.paymentType === 'wxpay'" 
                    style="background-color: #07C160; color: white; border: none;">
              <i class="el-icon-chat-dot-square"></i> 微信支付
            </el-tag>
            <el-tag v-else-if="currentPayment.paymentType === '支付宝' || currentPayment.paymentType === 'alipay'" 
                    style="background-color: #1677FF; color: white; border: none;">
              <i class="el-icon-coin"></i> 支付宝
            </el-tag>
            <el-tag v-else type="info">{{ currentPayment.paymentType }}</el-tag>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">交易类型：</div>
          <div class="detail-value">
            <el-tag type="primary">{{ currentPayment.tradeType }}</el-tag>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">交易状态：</div>
          <div class="detail-value">
            <el-tag v-if="currentPayment.tradeState === 'SUCCESS'" type="success" effect="dark">
              <i class="el-icon-circle-check"></i> 支付成功
            </el-tag>
            <el-tag v-else-if="currentPayment.tradeState === 'NOTPAY'" type="warning" effect="dark">
              <i class="el-icon-warning"></i> 未支付
            </el-tag>
            <el-tag v-else-if="currentPayment.tradeState === 'CLOSED'" type="info" effect="dark">
              <i class="el-icon-circle-close"></i> 已关闭
            </el-tag>
            <el-tag v-else>{{ currentPayment.tradeState }}</el-tag>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">支付金额：</div>
          <div class="detail-value amount">
            ¥{{ currentPayment.payerTotal ? (currentPayment.payerTotal / 100).toFixed(2) : '0.00' }}
          </div>
        </div>
        
        <div class="detail-row" v-if="currentPayment.content">
          <div class="detail-label">通知参数：</div>
          <div class="detail-value content">
            <el-input type="textarea" :rows="6" v-model="currentPayment.content" readonly></el-input>
          </div>
        </div>
        
        <div class="detail-row">
          <div class="detail-label">创建时间：</div>
          <div class="detail-value">
            <i class="el-icon-time"></i> {{ currentPayment.createTime }}
          </div>
        </div>
      </el-card>
      
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Paymeninfo",
  data() {
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      orderNo: "",
      username: "",
      tradeState: "",
      currentPayment: {},
      dialogFormVisible: false,
      multipleSelection: [],
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get("/paymentInfo/page", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderNo: this.orderNo,
          username: this.username,
          tradeState: this.tradeState,
        }
      }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    handleView(row) {
      this.currentPayment = JSON.parse(JSON.stringify(row))
      this.dialogFormVisible = true
    },
    del(id) {
      this.request.delete("/paymentInfo/" + id).then(res => {
        if (res.code === '200') {
          this.$message.success("删除成功")
          this.load()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    delBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择需要删除的数据")
        return
      }
      let ids = this.multipleSelection.map(v => v.id)
      this.request.post("/paymentInfo/del/batch", ids).then(res => {
        if (res.code === '200') {
          this.$message.success("批量删除成功")
          this.load()
        } else {
          this.$message.error("批量删除失败")
        }
      })
    },
    reset() {
      this.orderNo = ""
      this.username = ""
      this.tradeState = ""
      this.load()
    },
    handleSizeChange(pageSize) {
      console.log(pageSize)
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      console.log(pageNum)
      this.pageNum = pageNum
      this.load()
    }
  }
}
</script>

<style>
.headerBg {
  background: #eee!important;
}

.payment-detail-card {
  border: none;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  width: 120px;
  color: #909399;
  font-size: 14px;
  flex-shrink: 0;
  font-weight: 500;
}

.detail-value {
  flex: 1;
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}

.detail-value.amount {
  color: #f56c6c;
  font-weight: bold;
  font-size: 18px;
}

.detail-value.content {
  width: 100%;
}

.detail-value i {
  margin-right: 5px;
}
</style>
